import { collection, deleteDoc, doc, getDoc, serverTimestamp, setDoc, } from "firebase/firestore";
import { warnUnknownFields } from "./converterWarnings";
const TEST_ROUTING_FIELDS = [
    "id",
    "path",
    "phoneNumber",
    "agentId",
    "companyId",
    "createdAt",
    "updatedAt",
];
const testRoutingConverter = {
    toFirestore(value) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { id: _id, path: _path, ...data } = value;
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        warnUnknownFields("packages/ui TestRouting.fromFirestore", data, TEST_ROUTING_FIELDS);
        return {
            id: snapshot.id,
            path: snapshot.ref.path,
            phoneNumber: data.phoneNumber || snapshot.id,
            agentId: data.agentId,
            companyId: data.companyId,
            createdAt: data.createdAt?.toDate
                ? data.createdAt.toDate()
                : data.createdAt || null,
            updatedAt: data.updatedAt?.toDate
                ? data.updatedAt.toDate()
                : data.updatedAt || null,
        };
    },
};
export function testRoutingCollection(db) {
    return collection(db, "testRouting").withConverter(testRoutingConverter);
}
export function testRoutingDocument(db, phoneNumber) {
    return doc(db, "testRouting", phoneNumber).withConverter(testRoutingConverter);
}
export async function fetchTestRouting(db, phoneNumber) {
    const snapshot = await getDoc(testRoutingDocument(db, phoneNumber));
    return snapshot.exists() ? snapshot.data() : null;
}
export async function updateTestRouting(db, phoneNumber, data) {
    const docRef = testRoutingDocument(db, phoneNumber);
    const existing = await getDoc(docRef);
    const updates = {
        ...data,
        phoneNumber,
        updatedAt: serverTimestamp(),
    };
    if (!existing.exists()) {
        updates.createdAt = serverTimestamp();
    }
    await setDoc(docRef, updates, { merge: true });
}
export async function deleteTestRouting(db, phoneNumber) {
    await deleteDoc(testRoutingDocument(db, phoneNumber));
}
